import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { API_URL } from "variables/general";
import Button from "react-bootstrap/esm/Button";
import { Form } from "react-bootstrap";
import React from "react";

export default class UpdateBalance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  updateRFID = () => {
    let oldBalance = this.props.bal;
    let balance = this.state.balance;
    if (balance === null) {
      balance = oldBalance;
    }
    let ud_id = this.props.udId;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      // redirect: "follow",
      body: JSON.stringify({
        ud_id: ud_id,
        balance: balance,
      }),
    };
    fetch(API_URL + "/updaterfid", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let userDetail = JSON.parse(result);
        console.log(result);
        if (userDetail.status) {
          alert("Balance Updated Successfully");
          window.location.reload();
        } else alert("Error, Please try again later");
        this.setState({});
      })
      .catch((error) => console.log("error", error));
  };
  getBalance = (event) => {
    event.preventDefault();
    let val = event.target.value;
    this.setState({ balance: val });
  };
  render() {
    return (
      <>
        <Form>
          <Form.Label>Set Balance</Form.Label>
          <Input
            placeholder="Balance"
            type="number"
            onChange={this.getBalance.bind(this)}
          />
        </Form>
        <Button
          className="text-center"
          onClick={() => {
            this.updateRFID();
          }}
        >
          Update
        </Button>
      </>
    );
  }
}
